var _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalloon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "img-fluid",
    id: "outputsvg",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      transform: "none",
      transformOrigin: "50% 50%",
      cursor: "move"
    },
    width: 210,
    height: 393,
    viewBox: "0 0 2100 3930",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "l3weZGCKqjdH8mBvR9TD5jU",
    fill: "rgb(0,0,0)",
    style: {
      transform: "none"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "pxBtNR6xm",
    d: "M1053 3915 c-19 -21 -16 -45 13 -132 20 -58 27 -98 27 -154 0 -68 -5 -88 -48 -190 -26 -63 -59 -154 -72 -204 -22 -79 -24 -104 -19 -205 4 -99 20 -183 50 -277 7 -21 4 -23 -31 -23 -96 0 -160 -45 -147 -104 6 -34 60 -136 106 -203 l28 -41 -33 -8 c-303 -66 -595 -309 -761 -634 -122 -239 -167 -460 -144 -716 41 -476 348 -863 783 -989 119 -35 321 -45 441 -22 308 59 583 265 721 542 138 275 166 617 76 920 -126 425 -420 757 -778 881 -44 15 -81 28 -82 29 -2 1 24 51 57 111 93 169 81 215 -60 229 l-69 7 -17 56 c-44 154 -56 295 -33 404 7 29 34 103 60 165 27 61 54 135 60 164 18 84 7 221 -27 319 -27 80 -31 85 -59 87 -17 2 -36 -4 -42 -12z m55 -1384 l-42 -70 -36 57 c-20 31 -39 63 -44 70 -5 9 12 12 78 12 l85 0 -41 -69z m54 -290 c387 -99 738 -566 787 -1046 23 -224 -43 -475 -177 -671 -52 -77 -191 -210 -269 -257 -138 -84 -298 -132 -438 -131 -237 1 -510 139 -673 341 -74 91 -171 281 -202 394 -62 229 -32 513 79 745 151 316 410 552 681 623 95 25 120 25 212 2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l2yU8BsfDwcUMtACAxJHjCY",
    fill: "rgb(218,46,39)",
    style: {
      transform: "none"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "pNxER9vut",
    d: "M939 2593 c40 -79 112 -188 124 -188 13 0 66 75 116 166 l32 59 -146 0 -145 0 19 -37z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l4Sj1IXOgutSfp294cdpZV6",
    fill: "rgb(199,80,76)",
    style: {
      transform: "none"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "p1DXfSHOba",
    d: "M975 2283 c-11 -2 -53 -14 -93 -25 -68 -20 -73 -23 -70 -47 3 -25 6 -26 61 -26 31 0 57 -3 57 -7 0 -5 20 -8 44 -8 24 0 46 -5 48 -10 2 -6 21 -13 43 -17 22 -3 48 -14 58 -24 10 -11 29 -19 42 -19 16 0 25 -6 25 -15 0 -8 7 -15 15 -15 8 0 15 -4 15 -10 0 -5 7 -10 15 -10 8 0 15 -4 15 -10 0 -5 8 -10 18 -10 21 -1 67 -39 76 -63 3 -11 15 -21 26 -24 11 -3 20 -12 20 -19 0 -8 11 -19 25 -24 14 -5 25 -16 25 -25 0 -8 6 -15 13 -15 19 0 57 -43 57 -63 0 -9 7 -17 15 -17 17 0 85 -97 85 -121 0 -9 12 -29 26 -45 32 -33 74 -125 74 -158 0 -13 6 -26 14 -29 18 -7 53 -143 61 -239 4 -43 11 -78 16 -78 5 0 9 -49 9 -110 0 -60 -4 -110 -8 -110 -8 0 -32 -135 -32 -178 0 -12 -4 -22 -10 -22 -5 0 -10 -16 -10 -35 0 -19 -4 -35 -10 -35 -5 0 -10 -11 -10 -25 0 -14 -14 -55 -30 -92 -53 -117 -31 -162 42 -85 52 54 94 122 143 225 55 118 82 216 96 350 54 542 -326 1159 -789 1278 -69 17 -168 23 -217 12z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l4g9Wu34pmT1gjtDNWi0CFo",
    fill: "rgb(230,105,99)",
    style: {
      transform: "none"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "p1BmEW0cUk",
    d: "M1020 2280 c0 -5 11 -10 25 -10 14 0 25 5 25 10 0 6 -11 10 -25 10 -14 0 -25 -4 -25 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pj69BvEBg",
    d: "M754 2207 c-214 -116 -398 -316 -515 -561 -89 -187 -127 -404 -108 -621 13 -147 38 -236 109 -380 103 -210 235 -346 435 -445 140 -70 240 -94 390 -95 180 0 343 49 492 148 79 53 186 157 161 157 -13 0 -10 14 18 78 19 42 32 82 29 89 -2 6 0 13 5 15 5 2 10 17 12 33 2 17 7 33 11 36 5 3 9 22 10 42 1 20 6 37 11 37 4 0 6 11 4 25 -3 14 -1 25 5 25 5 0 7 15 4 35 -3 19 -2 35 4 35 5 0 9 60 9 140 0 77 -4 140 -8 140 -4 0 -6 16 -4 35 2 20 0 35 -6 35 -6 0 -8 8 -5 19 6 25 -44 213 -61 226 -7 6 -11 15 -9 22 6 16 -66 163 -83 170 -7 3 -11 9 -8 14 3 5 0 9 -6 9 -6 0 -8 4 -5 10 9 14 -73 130 -91 130 -8 0 -13 4 -10 9 8 12 -42 71 -60 71 -8 0 -13 5 -12 12 2 6 -8 17 -22 25 -14 7 -24 18 -22 23 1 6 -9 15 -23 20 -14 5 -28 18 -32 27 -8 25 -54 62 -75 63 -10 0 -18 5 -18 10 0 6 -7 10 -15 10 -8 0 -15 5 -15 10 0 6 -7 10 -15 10 -8 0 -15 7 -15 15 0 9 -9 15 -25 15 -13 0 -33 9 -43 21 -11 11 -36 22 -57 24 -21 2 -41 9 -45 15 -4 7 -26 12 -49 12 -23 0 -41 4 -41 10 0 7 -19 9 -56 5 -42 -4 -56 -2 -61 9 -8 20 -21 18 -89 -19z m-268 -1468 c35 -21 157 -160 212 -240 44 -65 49 -93 21 -112 -32 -23 -61 -5 -161 103 -117 127 -163 221 -126 258 15 15 15 16 54 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p17FFpgY8J",
    d: "M1270 2230 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "py6gOqrau",
    d: "M1447 2130 c3 -11 12 -20 19 -20 8 0 14 -4 14 -10 0 -5 7 -10 15 -10 21 0 19 8 -12 35 -34 30 -43 31 -36 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pmXYiLrEL",
    d: "M1610 1998 c41 -45 50 -53 50 -45 0 2 -21 23 -47 47 l-48 45 45 -47z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "l1oNYnzm8oXpc0ZQkvn1c3s",
    fill: "rgb(247,172,165)",
    style: {
      transform: "none"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "p19Zh4xNQm",
    d: "M485 1998 l-50 -53 53 50 c28 27 52 51 52 52 0 8 -9 -1 -55 -49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1FSl7B6UO",
    d: "M134 1135 c0 -49 1 -71 3 -48 2 23 2 64 0 90 -2 26 -3 8 -3 -42z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "py0UPxqtA",
    d: "M421 787 c-36 -18 -46 -67 -27 -130 9 -29 24 -64 34 -79 32 -48 175 -200 206 -219 38 -23 84 -24 115 -3 35 25 26 103 -19 170 -64 93 -181 224 -224 249 -49 29 -52 29 -85 12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pGpYsNM7Y",
    d: "M430 375 c19 -19 36 -35 39 -35 3 0 -10 16 -29 35 -19 19 -36 35 -39 35 -3 0 10 -16 29 -35z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalloon2);
export default __webpack_public_path__ + "static/media/balloon2.3b4f26e7a652a3b6ecb5ce12ef52cd6b.svg";
export { ForwardRef as ReactComponent };